/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ICopyData, IPasteData } from "./CopyPaste.types";
import { isNonEmptyArray } from "@adapptio/lib-shared";
import {
	ISchemaConstMapModelEntry,
	serializeIDTToData,
	TGenericBlueprintSchema,
	TGenericModelNode
} from "@adapptio/lib-blueprint";

function serializeModel(model: TGenericModelNode): any {
	return serializeIDTToData(model.schema.serialize(model, [ "$" ]));
}

function serializeMapEntry(mapEntry: ISchemaConstMapModelEntry<TGenericBlueprintSchema>): any {
	return { key: serializeModel(mapEntry.key), value: serializeModel(mapEntry.value) };
}

export function serializeCopyPasteData(data: ICopyData): string {
	const result: IPasteData = {};

	if (isNonEmptyArray(data.components)) {
		result.components = data.components.map((model) => serializeModel(model));
	}

	if (isNonEmptyArray(data.dataSources)) {
		result.dataSources = data.dataSources.map((model) => serializeModel(model));
	}

	if (isNonEmptyArray(data.parameters)) {
		result.parameters = data.parameters.map((mapEntry) => serializeMapEntry(mapEntry));
	}

	if (isNonEmptyArray(data.outlets)) {
		result.outlets = data.outlets.map((mapEntry) => serializeMapEntry(mapEntry));
	}

	if (isNonEmptyArray(data.viewEventNodes)) {
		result.viewEventNodes = data.viewEventNodes.map((model) => serializeModel(model));
	}

	if (isNonEmptyArray(data.flowNodes)) {
		result.flowNodes = data.flowNodes.map((model) => serializeModel(model));
	}

	return JSON.stringify(result);
}
